import * as CheckoutModels from "../../redux_store/checkout/model";

import cardImg from "../assets/icons/payment-icons/icon_payment_3.png";
import rewardsIcon from "../assets/icons/payment-icons/icon_payment_reward.png";
import GYGdollarIcon from "../assets/icons/payment-icons/icon_payment_gyg_dollar.png";
import { ImageSourcePropType } from "react-native";

export interface PaymentIcon {
  id: CheckoutModels.PaymentType;
  url: ImageSourcePropType;
  copy: string;
}

export const paymentTypeInfo: PaymentIcon[] = [
  {
    id: CheckoutModels.PaymentType.GYGDOLLAR,
    url: GYGdollarIcon,
    copy: "GYG Dollars",
  },
  {
    id: CheckoutModels.PaymentType.COUPON,
    url: rewardsIcon,
    copy: "Rewards",
  },
  {
    id: CheckoutModels.PaymentType.GIFTCARD,
    url: rewardsIcon,
    copy: "Rewards",
  },
  {
    id: CheckoutModels.PaymentType.CASH,
    url: cardImg,
    copy: "Cash",
  },
  {
    id: CheckoutModels.PaymentType.BRAINTREE,
    url: cardImg,
    copy: "Credit/Debit Card",
  },
];
